import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { APP_TYPE, AppType, isUSAApp } from '@models/AppType'
import environment from 'config/environment.ts'
import LanguageDetector from 'i18next-browser-languagedetector'
const defaultLocale = isUSAApp ? 'en' : 'fr'

export async function initializeI18n() {
  const locales = await loadLocales()

  return (
    i18n
      .use(LanguageDetector)
      // pass the i18n instance to react-i18next.
      .use(initReactI18next)
      // init i18next
      // for all options read: https://www.i18next.com/overview/configuration-options
      .init({
        resources: {
          ...locales,
        },
        detection: {
          lookupQuerystring: 'LANG',
          convertDetectedLanguage: (lang: string) => lang.toLowerCase().split('-')[0],
        },
        supportedLngs: ['fr', 'en', 'es'],
        load: 'languageOnly',
        cleanCode: true,
        fallbackLng: defaultLocale,
        nonExplicitSupportedLngs: true,
        initImmediate: false,
        debug: environment.isDev,

        interpolation: {
          escapeValue: false, // not needed for react as it escapes by default
        },
      })
  )
}

async function loadLocales() {
  switch (APP_TYPE) {
    case AppType.LQUE:
      return {
        fr: (await import('./books/fr.ts')).default,
        en: (await import('./books/en.ts')).default,
        es: (await import('./books/es.ts')).default,
      }
    case AppType.ELECTIONS_USA:
      return {
        fr: (await import('./usa/fr.ts')).default,
        en: (await import('./usa/en.ts')).default,
        es: (await import('./usa/es.ts')).default,
      }
    case AppType.SANTE:
      return {
        fr: (await import('./sante/fr.ts')).default,
        en: (await import('./sante/en.ts')).default,
        es: (await import('./sante/es.ts')).default,
      }
    case AppType.ELECTIONS_QUEBEC:
      return {
        fr: (await import('./quebec/fr.ts')).default,
        en: (await import('./quebec/en.ts')).default,
        es: (await import('./quebec/es.ts')).default,
      }

    default:
      return {
        fr: (await import('./default/fr.ts')).default,
        en: (await import('./default/en.ts')).default,
        es: (await import('./default/es.ts')).default,
      }
  }
}

export default initializeI18n
